import { Form, Select } from "antd";

import { useLossReasons } from "../../data/use-loss-reasons";
import { filterOption } from "./filter-option";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { getSelectOptions } from "../../utils/get-select-options";

export const LossReasonSelect = (props) => {
  const lossReasons = useLossReasons();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        filterOption={filterOption}
        optionFilterProp="children"
        options={getSelectOptions({
          store: lossReasons,
          initialIds: initialValue,
          labelKey: "label",
        })}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
